import {renderStructuredElements} from "@/utils/render-helpers.jsx";
import Newsletter from "@/components/Newsletter";

document.addEventListener("DOMContentLoaded", () => {
  renderStructuredElements("newsletter", Newsletter);
});
